import { UILogicActionType } from '@/reducers/V2/V2Actions/UILogic/UILogicTypes';

const initialState: any = {
  // menu
  selectedCategoryId: 0,
  isScrolling: true,
  showHeaderStoreName: false,
  showMemberDropDown: false,
  isLodedLocales: false,

  // attribute
  showAttributeModalAlert: false,
  attributeModalAlertMsg: false,

  // cart
  isCartCTAStatusDisabled: false,
  orderListInViewStatus: true,
  showCartErrorAlert: false,
  CartErrorAlertMsg: '',
  selectedPaymentAlert: false,
  isPreOrderTimeValid: true,

  // 共鍋費 是否開啟
  shareMealRuleOpen: false,

  // 滿額集點 是否開啟
  pricePointRuleOpen: false,
};

const UILogicReducer: (state: any, action: any) => any = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case UILogicActionType.SET_SELECTED_CATEGORY_ID:
      return {
        ...state,
        selectedCategoryId: payload,
      };
    case UILogicActionType.SET_IS_SCROLLING:
      return {
        ...state,
        isScrolling: payload,
      };
    case UILogicActionType.SET_SHOW_HEADER_STORE_NAME:
      return {
        ...state,
        showHeaderStoreName: payload,
      };
    case UILogicActionType.SET_SHOW_MEMBER_DROPDOWN:
      return {
        ...state,
        showMemberDropDown: payload,
      };
    case UILogicActionType.SET_IS_LOADED_LOCALES:
      return {
        ...state,
        isLodedLocales: payload,
      };
    case UILogicActionType.SET_SHOW_ATTRIBUTE_MODAL_ALERT:
      return {
        ...state,
        showAttributeModalAlert: payload,
      };
    case UILogicActionType.SET_ATTRIBUTE_MODAL_ALERT_MSG:
      return {
        ...state,
        attributeModalAlertMsg: payload,
      };
    case UILogicActionType.SET_CART_V2_INVIEW:
      return {
        ...state,
        orderListInViewStatus: payload,
      };
    case UILogicActionType.SET_CART_ERROR_ALERT:
      return {
        ...state,
        showCartErrorAlert: payload,
      };
    case UILogicActionType.SET_CART_ERROR_ALERT_MSG:
      return {
        ...state,
        CartErrorAlertMsg: payload,
      };
    case UILogicActionType.SET_CART_SELECTED_PAY_METHOD_ALERT:
      return {
        ...state,
        selectedPaymentAlert: payload,
      };
    case UILogicActionType.SET_SHAREMEAL_RULE_OPEN:
      return {
        ...state,
        shareMealRuleOpen: payload,
      };
    case UILogicActionType.SET_PRICEPOINT_RULE_OPEN:
      return {
        ...state,
        pricePointRuleOpen: payload,
      };
    case UILogicActionType.SET_IS_CART_CTA_STATUS_DISABLED:
      return {
        ...state,
        isCartCTAStatusDisabled: payload,
      };
    case UILogicActionType.SET_IS_CART_PREORDERTIME_VALID:
      return {
        ...state,
        isPreOrderTimeValid: payload,
      };

    default:
      return state;
  }
};

export default UILogicReducer;
